import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const StyledCompetitorDeleteButton = styled(IconButton)`
    & .SWReactIcons svg path {
        fill: ${colorsPalettes.carbon[200]};
    }
`;
